import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  flexGrow: 0,
  width: '100%',
};
